import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Struktura dostawy',
  subtitle: 'Wybierz sposób dostarczania zamówień (na lokalizację).',
  form: {
    delivery_mode: {
      label: 'Tryb dostawy',
      placeholder: 'Wybierz tryb dostawy',
      options: {
        [DeliveryMode.Internal]: 'Wewnętrzna (własni kierowcy)',
        [DeliveryMode.External]: 'Zewnętrzna (firma trzecia)',
      },
    },
  },
  buttons: {
    back: 'Wstecz',
    next: 'Dalej',
    skip: 'Pomiń',
  },
  toasts: {
    error: 'Coś poszło nie tak. Spróbuj ponownie.',
  },
};
